import { render, staticRenderFns } from "./TaskFinalDelivery.vue?vue&type=template&id=46ba270e&scoped=true&"
import script from "./TaskFinalDelivery.vue?vue&type=script&lang=js&"
export * from "./TaskFinalDelivery.vue?vue&type=script&lang=js&"
import style0 from "./TaskFinalDelivery.vue?vue&type=style&index=0&id=46ba270e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba270e",
  null
  
)

export default component.exports